<!-- ngIf trick below from https://medium.com/@yurykatkov/how-to-avoid-multiple-async-pipes-in-angular-ff0d51a8d368 -->
<ng-container
  *ngIf="{
    isPopoverDisplayed: isPopoverDisplayed$ | async,
    insets: insets$ | async,
    suggestions: suggestions$ | async,
    previewedInEditor: previewedInEditor$ | async
  } as asyncData">
  <ng-container *ngIf="asyncData.isPopoverDisplayed">
    <div (click)="dismissModal()" class="backdrop"></div>
    <div
      [style.top]="asyncData.insets.popover.top"
      [style.bottom]="asyncData.insets.popover.bottom"
      [style.left]="asyncData.insets.popover.left"
      [style.right]="asyncData.insets.popover.right"
      class="suggestions-popover">
      <ion-header>
        <ion-toolbar>
          <ion-title data-testid="suggestion-title">{{
            'm/task-process/favorites-suggestions/popover-title' | translate
          }}</ion-title>
          <ion-buttons slot="end">
            <ion-button (click)="dismissModal()">
              <ion-icon slot="icon-only" name="close"></ion-icon>
            </ion-button>
          </ion-buttons>
        </ion-toolbar>
      </ion-header>
      <ion-list>
        <ion-item
          *ngFor="let suggestion of asyncData.suggestions; let index = index; let last = last"
          [attr.data-testid]="'suggest-favorite-' + index"
          (click)="emitSelectedFavorite(suggestion.favorite)"
          [lines]="last ? 'none' : 'full'">
          <span class="suggestion-text">
            <span *ngFor="let chunk of suggestion.chunks" [ngClass]="{ highlighted: chunk.isHighlighted }">{{
              chunk.text
            }}</span>
          </span>
        </ion-item>
      </ion-list>
    </div>
    <div
      *ngIf="asyncData.previewedInEditor"
      [style.top]="asyncData.insets.preview.top"
      [style.bottom]="asyncData.insets.preview.bottom"
      [style.left]="asyncData.insets.preview.left"
      [style.right]="asyncData.insets.preview.right"
      class="preview-in-editor">
      {{ asyncData.previewedInEditor.preview }}
    </div>
  </ng-container>
</ng-container>
